import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import './PaymentBorica.scss';

const PaymentBorica = (props: any) => {
  const { delictId } = props.match.params;
  const [message, setMessage] = useState('');

  useEffect(() => {
    axios.get(`/payment/status/${delictId}`)
    .then(response => {
        const data = response.data || {};
        setMessage(data.responseMessage);
    })
    .catch(e => console.log(e));
  }, []);

  return (
    <Container className="payment-container">
      <div className="payment-note">
        <h4>{message}</h4>
      </div>
    </Container>
  );
};

export default PaymentBorica;
